import React from 'react';
import { setAutomationElement } from '@experian-uk/corvetteuk-common-ui';
import {
  BreachBenefitsContainer,
  FactSheetLink,
  FooterContent,
} from './index.styles';
import benefits from './benefits';
import { Benefit } from '../..';

const BreachBenefitsPanel = () => (
  <BreachBenefitsContainer {...setAutomationElement('breachBenefits')}>
    {benefits.map(benefit => (<Benefit key={benefit.title} {...benefit} />))}
    <FooterContent>
      <FactSheetLink
        href="https://www.experian.co.uk/consumer/product-factsheets/Identitypluspartneraug2019.pdf"
        rel="noopener noreferrer"
        target="_blank"
        {...setAutomationElement('breachProductFactsheet')}
      >
        View Identity Plus product fact sheet
      </FactSheetLink>
    </FooterContent>
  </BreachBenefitsContainer>
);

export default BreachBenefitsPanel;
